import { render, staticRenderFns } from "./UserMainGrid.vue?vue&type=template&id=944b2db8&scoped=true&"
import script from "./UserMainGrid.vue?vue&type=script&lang=ts&"
export * from "./UserMainGrid.vue?vue&type=script&lang=ts&"
import style0 from "./UserMainGrid.vue?vue&type=style&index=0&id=944b2db8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944b2db8",
  null
  
)

export default component.exports